import { Locale, type LocalizedString } from "./Locale.js";

export enum Department {
	Backoffice = "Backoffice",
	Management = "Management",
	Sales = "Sales",
	Service = "Service",
	Software = "Software",
}

export const departmentNameMap: Record<Department, LocalizedString> = {
	[Department.Service]: {
		[Locale.cs]: "Servis a podpora",
		[Locale.en]: "Service and Support",
		[Locale.pl]: "Serwis i wsparcie",
		[Locale.sk]: "Servis a podpora",
	},
	[Department.Sales]: {
		[Locale.cs]: "Prodej",
		[Locale.en]: "Sales",
		[Locale.pl]: "Sprzedaż",
		[Locale.sk]: "Predaj",
	},
	[Department.Software]: {
		[Locale.cs]: "Software",
		[Locale.en]: "Software",
		[Locale.pl]: "Software",
		[Locale.sk]: "Software",
	},
	[Department.Backoffice]: {
		[Locale.cs]: "Backoffice",
		[Locale.en]: "Backoffice",
		[Locale.pl]: "Backoffice",
		[Locale.sk]: "Backoffice",
	},
	[Department.Management]: {
		[Locale.cs]: "Management",
		[Locale.en]: "Management",
		[Locale.pl]: "Management",
		[Locale.sk]: "Management",
	},
};
